export default __webpack_public_path__ + "static/media/benefits-video.e9b4dc01.mp4";